import {
  useScenarioContext,
  variantIdentifierToString,
} from '../context/scenarioContext'
import { useCommitmentVersionSelection } from './useCommitmentVersionSelection'
import { useScenarioOverviewDefaultDiff } from './useScenarioOverviewDefaultDiff'

export type PreviousCommitmentContextHookVariant =
  | 'previousEvent'
  | 'previousSimulation'
  | 'previousScenarioSimulation'
  | 'simulateEmptyReality'
  | 'previousNone'

export function usePreviousCommitmentContextVariant(): PreviousCommitmentContextHookVariant {
  const { compareVariantIdentifier, scenarioIdForRequestHeader } =
    useScenarioContext()
  const { previousSelection, previousSelectionSimulationDate } =
    useCommitmentVersionSelection()

  const { isDiffingByDefault } = useScenarioOverviewDefaultDiff()

  const previousScenarioIdForRequestHeader = compareVariantIdentifier
    ? variantIdentifierToString(compareVariantIdentifier)
    : undefined

  if (
    isDiffingByDefault &&
    previousScenarioIdForRequestHeader === undefined &&
    scenarioIdForRequestHeader
  ) {
    return 'simulateEmptyReality'
  } else if (
    !isDiffingByDefault &&
    previousScenarioIdForRequestHeader === undefined &&
    scenarioIdForRequestHeader
  ) {
    return 'previousNone'
  } else if (
    previousSelection?.type === 'unappliedCommand' &&
    !!previousSelectionSimulationDate
  ) {
    return 'previousSimulation'
  } else if (previousSelection?.type === 'event') {
    return 'previousEvent'
  } else if (previousScenarioIdForRequestHeader) {
    return 'previousScenarioSimulation'
  }

  return 'previousNone'
}
